// noinspection JSDeprecatedSymbols

// ATTENTION: Remove navigator?.platform and leave only navigator?.userAgentData?.platform when it's supported by all browsers
export const platform =
  navigator?.userAgentData?.platform || navigator?.platform || 'unknown';
